export function getCannedResponseSearchPhrase(
  text: string,
  cannedResponseTriggerIndex: number,
  selectionEndIndex: number
): string {
  if (
    (cannedResponseTriggerIndex >= 0 && selectionEndIndex > cannedResponseTriggerIndex) ||
    cannedResponseTriggerIndex >= text.length
  ) {
    return text.substring(cannedResponseTriggerIndex + 1, selectionEndIndex);
  }
  return "";
}

export function insertIntoText(into: string, text: string, index: number, deleteCount = 0): string {
  return `${into.slice(0, index)}${text}${into.slice(index + Math.abs(deleteCount))}`;
}
